import { render } from "./SoftwareHardwareForm.vue?vue&type=template&id=596e2153&scoped=true"
import script from "./SoftwareHardwareForm.vue?vue&type=script&lang=js"
export * from "./SoftwareHardwareForm.vue?vue&type=script&lang=js"

import "./SoftwareHardwareForm.vue?vue&type=style&index=0&id=596e2153&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596e2153"]])

export default __exports__